export const TRANSLATIONS_PREFIX = 'TI2020_ContentTranslations_Header_Beta_suggetions_';

export const NON_SUPPORTED_FEATURES = [
    { translationKey: 'Automated_Solutions' },
    { translationKey: 'Question_Bank' },
    { translationKey: 'Themes' },
    { translationKey: 'Custom_JS' },
];
